import { store } from "src/store";
import { timerTick } from "src/store/timer/reducer";

let GlobalTimerInterval;

export default () => {
  GlobalTimerInterval = setInterval(() => {
    store.dispatch(timerTick());
  }, 1000);
};
